import React from 'react';
import { KatButton, KatCard } from '@amzn/katal-react';

import Form from 'react-jsonschema-form';
import { JSONSchema6 } from "json-schema";

import createCheckoutSessionSchema from '../schema/createCheckoutSessionSchema'
import getChargeSchema from '../schema/getChargeSchema'
import getCheckoutSessionSchema from '../schema/getCheckoutSessionSchema';
import updateCheckoutSessionSchema from '../schema/updateCheckoutSessionSchema';
import completeCheckoutSessionSchema from '../schema/completeCheckoutSessionSchema';
import finalizeCheckoutSessionSchema from '../schema/finalizeCheckoutSessionSchema';
import createChargeSchema from '../schema/createChargeSchema';
import captureChargeSchema from '../schema/captureChargeSchema';
import cancelChargeSchema from '../schema/cancelChargeSchema';
import getChargePermissionSchema from '../schema/getChargePermissionSchema';
import updateChargePermissionSchema from '../schema/updateChargePermissionSchema'
import closeChargePermissionSchema from '../schema/closeChargePermissionSchema';
import createRefundSchema from '../schema/createRefundSchema';
import getRefundSchema from '../schema/getRefundSchema';
import deliveryTrackerSchema from '../schema/deliveryTrackerSchema';
import getBuyerSchema from '../schema/getBuyerSchema';
import getReportsSchema from '../schema/getReportsSchema';
import getReportByIdSchema from '../schema/getReportByIdSchema';
import createReportSchema from '../schema/createReportSchema';
import getReportDocumentSchema from '../schema/getReportDocumentSchema';

import { RJSF_CUSTOM_PREFIX, AUDIT_API_URL, COGNITO_POOL_ID, AWS_REGION, PRODUCTION } from 'src/appConstants';
import { CustomObjectFieldTemplate } from 'src/rjsf/CustomObjectFieldTemplate';
import { CustomFieldTemplate } from 'src/rjsf/CustomFieldTemplate';
import { CustomArrayFieldTemplate } from 'src/rjsf/CustomArrayFieldTemplate';
import { CustomWidgets } from 'src/rjsf/WidgetOverride';
import { CustomEventHandler, EventHandler } from '../../utils/customEventHandler'
import initialMetricsPublisher from '../../metrics';

import '../App.scss';
import { buildRequest } from '../../utils/requestHelper';
import { browserName } from "react-device-detect";
import AWS from 'aws-sdk';
import { ApiClient } from 'src/utils/APIGatewayClient';
const uuidv4 = require('uuid/v4');
const apigClientFactory = require('aws-api-gateway-client').default;
const schemaMap = {
    'createCheckoutSession': createCheckoutSessionSchema,
    'getCheckoutSession': getCheckoutSessionSchema,
    'updateCheckoutSession': updateCheckoutSessionSchema,
    'completeCheckoutSession': completeCheckoutSessionSchema,
    'finalizeCheckoutSession': finalizeCheckoutSessionSchema,
    'getChargePermission': getChargePermissionSchema,
    'updateChargePermission': updateChargePermissionSchema,
    'closeChargePermission': closeChargePermissionSchema,
    'getCharge': getChargeSchema,
    'createCharge': createChargeSchema,
    'captureCharge': captureChargeSchema,
    'cancelCharge': cancelChargeSchema,
    'createRefund': createRefundSchema,
    'getRefund': getRefundSchema,
    'deliveryTracker': deliveryTrackerSchema,
    'getBuyer': getBuyerSchema,
    'getReports': getReportsSchema,
    'getReportById': getReportByIdSchema,
    'createReport': createReportSchema,
    'getReportDocument': getReportDocumentSchema    
}

class ApiRequest extends React.Component<{apiRequestSchema:string, authValues:any}> {
    eventHandler: CustomEventHandler;
    stage: any;

    constructor(props: Readonly<{apiRequestSchema: string, authValues:any}>) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.eventHandler = EventHandler;
        this.stage = process.env.NODE_ENV;
    }

    onSubmit(formData: any) {
        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("ApiSubmit_" + this.props.apiRequestSchema);
        actionMetricsPublisher.publishCounterMonitor('visits', 1);

        const elementAccordionResponse = document.getElementById("InterimAccordionResponse");
        if (elementAccordionResponse) {
            elementAccordionResponse.setAttribute("expanded", "expanded");
        }

        const signedComponents = buildRequest(window.location.hostname, formData, this.props.authValues, this.props.apiRequestSchema);
        signedComponents.formData = formData;
        fetch("https://" + signedComponents.host + "/" + signedComponents.urlFragment, {
            method: signedComponents.method,
            cache: 'no-cache',
            headers: signedComponents.signedHeaders,
            body: signedComponents.payload
        })
        .then(res => res.json().then(data => ({status: res.status, requestId: res.headers.get('x-amz-pay-request-id'), body: data})))
        .then(
            (result) => {
                signedComponents.status = String(result.status);
                signedComponents.requestId = String(result.requestId);
                signedComponents.responseBody = JSON.stringify(result.body, null, 4);
            },
            (error) => {
                signedComponents.responseBody = String(error);
            }
        )
        .finally(() => {
            this.eventHandler.emit('apiEvent', signedComponents);
            // Method Call to Store data for Auditing Purpose
            this.logAuditData(signedComponents, formData);
        });

    }

    getApiSchema() {
        return schemaMap[this.props.apiRequestSchema] || createCheckoutSessionSchema;
    }

    render() {
        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod("ApiPage_" + this.props.apiRequestSchema);
        actionMetricsPublisher.publishCounterMonitor('visits', 1);

        var apiSchema = this.getApiSchema() as JSONSchema6;
        return (
            <KatCard className="Scratchpad_Component">

                <Form
                    // Adding Key which is Unique to contain Fresh Form without having validation while redenring.  
                    // This was introduced to fix the issue : https://tiny.amazon.com/3y7u38gb
                    key={Date.now()} 
                    schema={apiSchema}
                    idPrefix={RJSF_CUSTOM_PREFIX}
                    ObjectFieldTemplate={CustomObjectFieldTemplate}
                    FieldTemplate={CustomFieldTemplate}
                    ArrayFieldTemplate={CustomArrayFieldTemplate}
                    widgets={CustomWidgets}
                    showErrorList={false}
                    noHtml5Validate
                    liveValidate={false}
                    onSubmit={this.onSubmit}
                >
                    <KatButton label="Submit" type="submit" variant="primary" />
                </Form>

            </KatCard>
        );
    }

    apiCall(requestBody) {
        const apiGatewayClient = new ApiClient(this.stage === PRODUCTION ? AUDIT_API_URL.production : AUDIT_API_URL.development);
        var pathParams = {}
        var pathTemplate = '/prod';

        apiGatewayClient.post<any>(pathTemplate,requestBody,pathParams).then(function (result) {
        }).catch(function (err) {
            console.log(err);
        });
    }

    // Method used to store the audit data to DynamoDB by calling API gateway
    logAuditData(signedComponents, formData) {
        // Building Request body to call Audit API (i.e HTTP Method - POST)
        const requestBody = this.getRequestBody(signedComponents, formData)
        // Budiling request options

        this.apiCall(requestBody);
    }

    // Method to build request body & return JSON
    getRequestBody(signedComponents, formData) {
        return { 
            "TableName": "ScratchPadAuditTrail",
            "Item": {
                "id": {
                    "S": uuidv4().toString()
                },
                "region": {
                    "S": this.props.authValues.region.toUpperCase()
                },
                "publicKeyId":{
                    "S": this.props.authValues.publicKeyId
                 },
                "requestId":{
                    "S": signedComponents.requestId
                },
                "api": {
                    "S": formData.schema.title
                },
                "responseCode":{
                    "S": signedComponents.status
                },
                "dateTime": {
                    "S": signedComponents.signedHeaders['x-amz-pay-date']
                },
                "browser":{
                    "S": browserName
                },
                "userAgent":{
                    "S": navigator.userAgent
                }
            }
        };
    }
}

export default ApiRequest;
